
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { APP_VERSION } from './utils/versionControl'

// Log the current version to console for debugging
console.log(`ScoutLink.ai v${APP_VERSION}`);

// Initialize root element for React
createRoot(document.getElementById("root")!).render(<App />);

// Add version information as meta tag for reference
const metaVersion = document.createElement('meta');
metaVersion.name = 'app-version';
metaVersion.content = APP_VERSION;
document.head.appendChild(metaVersion);
